// pages/PendingBillsPage.jsx
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import SettleBillModal from "../components/SettleBillModal";
// import KOTPrintLayout from "../components/KOTPrintLayout";
import BillPrintLayout from "../components/BillPrintLayout";
import { useAuth } from "../context/AuthContext";
import { useParams } from "react-router-dom";
import { getPendingBills, ungenerateBill } from "../api/orderApi";

export default function PendingBillsPage() {
  const { user } = useAuth();
  const [bills, setBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBillId, setSelectedBillId] = useState(null); // Track selected row index
  const [isSettleModalOpen, setIsSettleModalOpen] = useState(false);
  const [activePrintData, setActivePrintData] = useState(null);
  const { tableId } = useParams();
  const restaurantId = user?.restaurantId;

  // Sync Data (Simulating billing_table structure)
  useEffect(() => {

    if (!restaurantId) return;

    const loadPendingBills = async () => {
      // This will now log strictly when the user logs in or switches locations

      try {
        const data = await getPendingBills(restaurantId);
        // setCategories(data);
        if (data.length > 0) {
          setBills(data);

          // Auto-select the first item if available
          if (data.length > 0) {
            if (tableId) {
              setSelectedBillId(tableId);
            } else {
              setSelectedBillId(data[0].id);
            }

          }
          //setSelectedCategory(data[0]);
        }
      } catch (error) {
        console.error("Error loading Pending Bills:", error);
      }
    };

    loadPendingBills();
  }, [restaurantId, tableId, user]);

  // Find the complete object context of the active row selection
  const selectedBill = bills.find((b) => b.id === selectedBillId);

  // Action B: Reprint
  const handleReprint = () => {
    //console.log(selectedBill);
    if (!selectedBill) return;
    setActivePrintData(selectedBill);
    setTimeout(() => {
      window.print();
      setActivePrintData(null);
    }, 100);
  };

  // Action C: Un-generate Bill
  const handleUngenerate = async () => {
    if (!selectedBill) return;
    const isConfirmed = window.confirm(`Un-generate bill for ${selectedBill.seatingName}? Items will return to active status.`);
    if (!isConfirmed) return;

    const selected_Bill = bills.find(b => b.id === selectedBillId);

    if (!selected_Bill) {
      console.error("No bill found for id:", selectedBillId);
      return;
    }

    const ungeneratePayload = {
      billId: selected_Bill.bill_id,
      restaurantId: restaurantId,
      seatingName: selected_Bill.seatingName,
      seatingId: selected_Bill.seating_id
    };
    try {
      await ungenerateBill(ungeneratePayload);
    } catch (error) {
      console.error("Error ungenerating bill:", error);

    }

    // 
    // await ungenerate();
    setBills((prev) => {
      const updated = prev.filter((b) => b.id !== selectedBill.id);
      // Auto-select next available row
      setSelectedBillId(updated.length > 0 ? updated[0].id : null);
      return updated;
    });
  };

  // Action A: Settlement Modal Submission Callback
  const handleSettlementComplete = (billId, updatedStatus, amountPaid) => {
    setBills((prev) => {
      // 1. If the bill is completely settled, remove it from the array list completely
      if (updatedStatus === "Settled") {
        return prev.filter((b) => b.id !== billId);
      }

      // 2. If it's only a Part-Settlement, keep it in the list but update its amounts dynamically
      /* return prev.map((b) =>
        b.id === billId
          ? {
            ...b,
            status: updatedStatus, // Will be "Part-Settled"
            settledAmount: (Number(b.settledAmount || 0) + Number(amountPaid))
          }
          : b
      );*/
    });
  };

  const filteredBills = bills.filter((b) =>
    b.seatingName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const statusBadges = {
    "Generated": "bg-amber-100 text-amber-800",
    "Part-Settled": "bg-blue-100 text-blue-800",
    "Settled": "bg-green-100 text-green-800"
  };

  return (
      <div className="p-2 bg-gray-100 h-[calc(100vh-100px)] flex flex-col font-sans overflow-hidden print:hidden">

        {/* Top Controller Search Bar Section */}
        <div className="flex justify-between items-center bg-white p-2 rounded-xl shadow-sm mb-4">
          <div>
            <h1 className="text-xs font-black text-gray-900">🧾 Pending Bills Ledger</h1>
            <p className="text-xs indent-[18px] text-gray-500">Select a table row below to manage settlements and receipts.</p>
          </div>
          <input
            type="text"
            placeholder="Filter by Table Name..."
            className="w-64 px-3 py-1.5 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Main Two-Column Layout Panel Grid Split */}
        <div className="flex-1 grid grid-cols-12 gap-4 overflow-hidden">

          {/* LEFT COLUMN: Clean Table Rows Row Collection (7 Columns Wide) */}
          <div className="col-span-7 bg-white rounded-xl shadow-sm border border-gray-100 overflow-y-auto flex flex-col">
            <table className="w-full text-left border-collapse">
              <thead className="sticky top-0 border-b text-xs text-gray-500 uppercase tracking-wider font-semibold z-10">
                <tr>
                  <th className="p-4">Table</th>
                  <th className="p-4">Bill ID</th>
                  <th className="p-4">Status</th>
                  <th className="p-4 text-right">Grand Total</th>
                </tr>
              </thead>
              <tbody className="divide-y text-sm text-gray-700">
                {filteredBills.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center p-8 text-gray-400 italic">No pending tickets found.</td>
                  </tr>
                ) : (
                  filteredBills.map((b) => {
                    const isSelected = b.id === selectedBillId;
                    return (
                      <tr
                        key={b.id}
                        onClick={() => setSelectedBillId(b.id)}
                        className={`cursor-pointer transition-colors ${isSelected
                          ? "bg-indigo-500 font-medium border-l-4 border-l-indigo-600"
                          : "hover:bg-indigo-400"
                          }`}
                      >
                        <td className="p-4 font-bold text-gray-900">{b.seatingName}</td>
                        <td className="p-4 text-xs font-mono text-gray-500">{b.id}</td>
                        <td className="p-4">
                          <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${statusBadges[b.status]}`}>
                            {b.status}
                          </span>
                        </td>
                        <td className="p-4 text-right font-bold text-gray-900">₹{b.total_bill_amount.toFixed(2)}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* RIGHT COLUMN: Action Buttons & Context Viewer (5 Columns Wide) */}
          <div className="col-span-5 bg-white rounded-xl shadow-sm border border-gray-100 p-2 flex flex-col justify-between overflow-y-auto">
            {selectedBill ? (
              <>
                {/* Context Summary Meta Details */}
                <div className="space-y-4">
                  <div className="border-b pb-1">
                    <span className="text-[10px] uppercase font-bold tracking-widest text-gray-400">Selected Table: {selectedBill.seatingName}
                      {selectedBill.total_bill_amount - selectedBill.settledAmount > 0 ? (
                        <button
                          onClick={() => setIsSettleModalOpen(true)}
                          className="w-full bg-green-600 hover:bg-green-700 text-white text-sm font-black py-3 rounded-xl shadow-sm transition flex items-center justify-center gap-1.5"
                        >
                          Collect / Settle Payment 💵
                        </button>
                      ) : (
                        <div className="w-full text-center text-xs text-green-700 font-bold bg-green-100/50 border border-green-200 py-3 rounded-xl">
                          ✓ Account Fully Cleared & Settled
                        </div>
                      )}

                    </span>
                  </div>

                  {/* Live Itemizer Preview Area (Action D: View Built-in) */}
                  <div className="space-y-2">
                    <div className="border rounded-xl p-3 max-h-48 overflow-y-auto divide-y divide-gray-100 text-xs">
                      {selectedBill.products.map((p, idx) => (
                        <div key={idx} className="py-1 flex justify-between first:pt-0 last:pb-0">
                          <span className="text-gray-800"><span className="font-bold text-gray-900">{p.quantity}x</span> {p.name}</span>
                          <span className="font-semibold text-gray-700">₹{(p.quantity * p.price).toFixed(2)}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Pricing Ledger Aggregates Card */}
                  <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 space-y-1.5 text-xs text-gray-600">
                    <div className="flex justify-between">
                      <span>Gross Value Amount:</span>
                      <span>₹{selectedBill.subTotal.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Tax Surcharges (CGST/SGST):</span>
                      <span>₹{selectedBill.calculated_GST.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between text-green-600 font-medium">
                      <span>Paid Collection Value:</span>
                      <span>₹{selectedBill.settledAmount.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between text-sm font-black text-gray-900 border-t border-dashed pt-2 mt-1">
                      <span>Outstanding Dues:</span>
                      <span className={selectedBill.total_bill_amount - selectedBill.settledAmount > 0 ? "text-red-600" : "text-gray-500"}>
                        ₹{(selectedBill.total_bill_amount - selectedBill.settledAmount).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Functional Actions Footer Matrix Panel Block */}
                <div className="space-y-2 pt-1 border-t mt-1">
                  <div className="grid grid-cols-2 gap-2">
                    <button
                      onClick={handleReprint}
                      className="w-full bg-indigo-50 hover:bg-indigo-100 text-indigo-700 text-xs font-bold py-2.5 rounded-xl transition border border-indigo-100 flex items-center justify-center gap-1.5"
                    >
                      Reprint Bill 🖨️
                    </button>

                    {selectedBill.status !== "Settled" && (
                      <button
                        onClick={handleUngenerate}
                        className="w-full bg-rose-50 hover:bg-rose-100 text-rose-700 text-xs font-bold py-2.5 rounded-xl transition border border-rose-100 flex items-center justify-center gap-1.5"
                      >
                        Un-Generate Bill ↩️
                      </button>
                    )}
                  </div>

                  {selectedBill.total_bill_amount - selectedBill.settledAmount > 0 ? (
                    <button
                      onClick={() => setIsSettleModalOpen(true)}
                      className="w-full bg-green-600 hover:bg-green-700 text-white text-sm font-black py-3 rounded-xl shadow-sm transition flex items-center justify-center gap-1.5"
                    >
                      Collect / Settle Payment 💵
                    </button>
                  ) : (
                    <div className="w-full text-center text-xs text-green-700 font-bold bg-green-100/50 border border-green-200 py-3 rounded-xl">
                      ✓ Account Fully Cleared & Settled
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="h-full flex flex-col items-center justify-center text-center text-gray-400 italic text-sm">
                Select an active table row on the left to display action panels.
              </div>
            )}
          </div>
        </div>

        {/* Action A: Settle Payment Overlay popup view */}
        {isSettleModalOpen && selectedBill && (
          <SettleBillModal
            bill={selectedBill}
            onClose={() => setIsSettleModalOpen(false)}
            onSettleComplete={handleSettlementComplete}
          />
        )}

        {/* Independent Print Portal Hook */}
        {activePrintData && createPortal(
          <BillPrintLayout data={activePrintData}></BillPrintLayout>,
          //<KOTPrintLayout data={activePrintData} user={user} />,
          //<BillPrintLayout data={currentJob} />,
          document.body
        )}
      </div>
  );
}